// Corsac section scripts. Each section's Liquid renders its markup and a JSON config
// (<script type="application/json" data-cx-config>); the products it needs are in the page's seed.
// Sections initialise on load and again when the theme editor re-renders them.
(function () {
  const CX = window.CX;
  const { $, $$, esc, icon, roll } = CX;
  const R = CX.routes;
  const config = (sec) => { const el = $('script[data-cx-config]', sec); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } };
  const pad = (n) => String(n).padStart(2, '0');
  const cleanups = new WeakMap();
  const onScrollFrame = (sec, fn) => {
    let frame = 0;
    const req = () => { if (!frame) frame = requestAnimationFrame(() => { frame = 0; fn(); }); };
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    const list = cleanups.get(sec) || [];
    list.push(() => { window.removeEventListener('scroll', req); window.removeEventListener('resize', req); });
    cleanups.set(sec, list);
    fn();
  };

  // Word tabs (cx-chip) switching panels; works on server-rendered tab lists.
  const wireTabs = (list, onPick) => {
    list.addEventListener('click', (e) => {
      const b = e.target.closest('.cx-chip');
      if (!b || b.classList.contains('is-on')) return;
      $$('.cx-chip', list).forEach((c) => { c.classList.toggle('is-on', c === b); c.setAttribute('aria-selected', c === b); });
      onPick(Number(b.dataset.i));
    });
  };

  /* ---------- Size picker + add (Shop the look) ---------- */
  const sizeRow = (p) => (p.sizes || []).filter(Boolean).map((s) => `<button class="cx-size" data-size="${esc(s)}"${CX.isSold(p, s) ? ' disabled' : ''}>${esc(s)}</button>`).join('');
  const buyBox = (root) => {
    root.addEventListener('click', (e) => {
      const size = e.target.closest('.cx-size');
      const box = e.target.closest('[data-cx-buy]');
      if (!box) return;
      if (size) {
        $$('.cx-size', box).forEach((b) => b.classList.toggle('is-on', b === size));
        const hint = $('[data-cx-hint]', box);
        if (hint) hint.textContent = '';
      }
      const add = e.target.closest('[data-cx-add]');
      if (!add) return;
      const p = CX.byId(box.dataset.cxBuy);
      const picked = $('.cx-size.is-on', box);
      if ((p.sizes || []).filter(Boolean).length && !picked) {
        const hint = $('[data-cx-hint]', box);
        if (hint) hint.textContent = 'Choose a size first.';
        return;
      }
      CX.cart.add(p.id, picked ? picked.dataset.size : '').then(() => CX.open('cart'));
    });
  };

  // Rail with progress line and arrows.
  const wireRail = (sec) => {
    const rail = $('[data-cx-rail]', sec);
    const bar = $('.cx-progress > span', sec);
    const prev = $('[data-cx-prev]', sec);
    const next = $('[data-cx-next]', sec);
    if (!rail || !bar) return;
    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const share = Math.min(1, rail.clientWidth / Math.max(1, rail.scrollWidth));
      bar.style.width = (share * 100).toFixed(1) + '%';
      bar.style.transform = `translateX(${max > 0 ? ((rail.scrollLeft / max) * ((1 - share) / share) * 100).toFixed(1) : 0}%)`;
      prev.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft > max - 4;
    };
    const step = (dir) => { const card = rail.firstElementChild; if (card) rail.scrollBy({ left: dir * card.offsetWidth * (CX.wide() ? 2 : 1), behavior: 'smooth' }); };
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  };

  const init = {
    /* Mobile banner and category grid: markup from Liquid, tabs here */
    'mobile-banner'(sec) {
      // Swipe cards: the card in view decides which category links show underneath.
      const cards = $('[data-cx-mcards]', sec);
      if (cards) {
        const items = $$('.cx-mcard2', cards);
        const dots = $$('.cx-mcards__dots i', sec);
        const panels = $$('.cx-mcards__links', sec);
        let on = 0;
        const sync = () => {
          const mid = cards.scrollLeft + cards.clientWidth / 2;
          let best = 0;
          items.forEach((c, k) => { if (Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid) < Math.abs(items[best].offsetLeft + items[best].offsetWidth / 2 - mid)) best = k; });
          if (best === on) return;
          on = best;
          dots.forEach((d, k) => d.classList.toggle('is-on', k === on));
          panels.forEach((p, k) => { p.hidden = k !== on; });
        };
        cards.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
        return;
      }
      const list = $('[data-cx-mtabs]', sec);
      if (list) wireTabs(list, (i) => $$('.cx-mbanner__panel', sec).forEach((p) => { p.hidden = Number(p.dataset.i) !== i; }));
    },
    categories(sec) {
      const list = $('[data-cx-ctabs]', sec);
      if (!list) return;
      wireTabs(list, (i) => $$('.cx-cats__grid', sec).forEach((g) => {
        const on = Number(g.dataset.i) === i;
        g.hidden = !on;
        if (on) { g.classList.remove('is-in-tab'); void g.offsetWidth; g.classList.add('is-in-tab'); $$('[data-cx-unveil]', g).forEach((el) => el.classList.add('is-in')); }
      }));
    },

    /* Hero video (Shopify-hosted): loads after the page, skipped on save-data, slow networks and reduced motion */
    hero(sec) {
      const video = $('video[data-cx-video]', sec);
      if (!video) return;
      const conn = navigator.connection || {};
      if (CX.calm || conn.saveData || /2g/.test(conn.effectiveType || '') || !CX.wide()) return;
      const start = () => {
        $$('source[data-src]', video).forEach((s) => { s.src = s.dataset.src; });
        video.load();
        video.addEventListener('playing', () => sec.classList.add('has-video'), { once: true });
        const play = () => { const p = video.play(); if (p && p.catch) p.catch(() => {}); };
        new IntersectionObserver((en) => en.forEach((x) => (x.isIntersecting ? play() : video.pause()))).observe(sec);
      };
      if (document.readyState === 'complete') setTimeout(start, 400); else window.addEventListener('load', () => setTimeout(start, 400), { once: true });
    },

    /* Product carousel (Best sellers): same cards and rail as "You may also like" */
    carousel(sec, cfg) {
      const rail = $('[data-cx-rail]', sec);
      const ranked = cfg.layout === 'ranked';
      rail.innerHTML = (cfg.handles || []).map(CX.byId).filter(Boolean).map((p, i) => CX.card(p, { delay: Math.min(i, 5) * 60, rank: ranked ? i + 1 : 0 })).join('');
      wireRail(sec);
    },

    /* Product tabs (New arrivals): ruled grid, whole rows */
    tabs(sec, cfg) {
      const chips = $('[data-cx-chips]', sec);
      const grid = $('[data-cx-grid]', sec);
      const more = $('[data-cx-more]', sec);
      const lists = (cfg.tabs || []).map((t) => ({ ...t, items: (t.handles || []).map(CX.byId).filter(Boolean) }));
      if (!lists.length) return;
      chips.innerHTML = lists.length > 1 ? lists.map((l, i) => `<button class="cx-chip${i ? '' : ' is-on'}" data-i="${i}" aria-pressed="${!i}">${esc(l.label)}${l.count ? `<sup>${l.count}</sup>` : ''}</button>`).join('') : '';
      // The first tab's pieces often appear in the others too (unisex products); later tabs put the pieces you
      // haven't seen yet first, so switching tabs never looks like the same row again.
      let seenFirst = null;
      const show = (i) => {
        const max = cfg.layout === 'lead' ? 4 : Number(cfg.columns) || 5;
        const cols = window.matchMedia('(min-width: 1200px)').matches ? max : window.matchMedia('(min-width: 1100px)').matches ? Math.min(max, 4) : window.matchMedia('(min-width: 768px)').matches ? 3 : 2;
        let items = lists[i].items;
        if (i > 0 && seenFirst) items = [...items.filter((p) => !seenFirst.has(p.id)), ...items.filter((p) => seenFirst.has(p.id))];
        const lead = cfg.layout === 'lead' && cols > 2;
        // The lead tile takes a 2 x 2 block, so the rest fill whole rows around it.
        const slots = lead ? items.length + 3 : items.length;
        if (cfg.wholeRows !== false && slots > cols) items = items.slice(0, items.length - (slots % cols));
        grid.innerHTML = items.map((p, k) => CX.card(p, { delay: (k % cols) * 70, lead: lead && k === 0 })).join('');
        if (i === 0) seenFirst = new Set(items.map((p) => p.id));
        if (more) { more.href = lists[i].url || R.shop; more.hidden = !lists[i].url; }
        if (CX.observe) CX.observe(grid);
      };
      chips.addEventListener('click', (e) => {
        const b = e.target.closest('.cx-chip');
        if (!b || b.classList.contains('is-on')) return;
        $$('.cx-chip', chips).forEach((c) => { c.classList.toggle('is-on', c === b); c.setAttribute('aria-pressed', c === b); });
        show(Number(b.dataset.i));
      });
      show(0);
    },

    /* Shop the look: hotspots on the outfit; the second photo follows the piece you point at */
    look(sec, cfg) {
      const items = (cfg.items || []).filter(Boolean).map((x) => ({ ...x, p: CX.byId(x.id) })).filter((x) => x.p);
      const main = $('[data-cx-look-main]', sec);
      $$('.cx-hot', main).forEach((h) => h.remove());
      main.insertAdjacentHTML('beforeend', items.map((x, i) => `
        <div class="cx-hot${x.x > 60 ? ' cx-hot--left' : ''}" style="left:${x.x}%;top:${x.y}%" data-i="${i}">
          <button class="cx-hot__dot" aria-label="${esc(x.p.name)}"></button>
          <a class="cx-hot__tag" href="${R.product(x.p.id)}">${CX.pic(x.thumb || x.p.gallery[0], { w: 160, sizes: '48px' })}<span><strong>${esc(x.p.name)}</strong>${CX.price(x.p)}</span></a>
        </div>`).join(''));
      const frames = [{ img: cfg.detail || cfg.img, cap: cfg.caption ? esc(cfg.caption) : '' }, ...items.map((x) => ({ img: x.thumb || x.p.gallery[0], cap: `<b>${esc(x.p.name)}</b>${CX.price(x.p)}` }))];
      const frameBox = $('[data-cx-look-frames]', sec);
      const caption = $('[data-cx-look-caption]', sec);
      if (frameBox) {
        frameBox.innerHTML = frames.map((f, i) => CX.pic(f.img, { sizes: '(min-width: 900px) 24vw, 50vw', cls: i ? '' : 'is-on' })).join('');
        caption.innerHTML = frames[0].cap;
      }
      $('[data-cx-look-list]', sec).innerHTML = items.map((x, i) => `
        <div class="cx-piece" data-i="${i}" data-cx-buy="${esc(x.p.id)}">
          <a class="cx-piece__img" href="${R.product(x.p.id)}">${CX.pic(x.p.gallery[0], { w: 240, sizes: '64px' })}</a>
          <div class="cx-piece__body">
            <a class="cx-piece__name" href="${R.product(x.p.id)}">${esc(x.p.name)}</a>
            ${CX.price(x.p)}
            ${x.p.inStock ? `<div class="cx-sizes">${sizeRow(x.p)}</div>
            <div class="cx-piece__add"><button class="cx-btn cx-btn--sm" data-cx-add>${roll('Add to cart')}</button><span class="cx-hint" data-cx-hint></span></div>` : '<p class="cx-hint">Sold out</p>'}
          </div>
        </div>`).join('');
      buyBox(sec);
      const hots = $$('.cx-hot', main);
      const rows = $$('.cx-piece', sec);
      const imgs = frameBox ? $$('img', frameBox) : [];
      let on = 0;
      const light = (i) => {
        hots.forEach((h, k) => h.classList.toggle('is-on', k === i));
        rows.forEach((r, k) => r.classList.toggle('is-hot', k === i));
        const f = i + 1;
        if (!imgs.length || f === on || !imgs[f]) return;
        imgs[on].classList.remove('is-on');
        imgs[f].classList.add('is-on');
        caption.classList.remove('is-in');
        void caption.offsetWidth;
        caption.innerHTML = frames[f].cap;
        caption.classList.add('is-in');
        on = f;
      };
      main.addEventListener('pointerover', (e) => { const h = e.target.closest('.cx-hot'); if (h) light(Number(h.dataset.i)); });
      main.addEventListener('pointerleave', () => light(-1));
      main.addEventListener('click', (e) => { const d = e.target.closest('.cx-hot__dot'); if (d) light(Number(d.parentElement.dataset.i)); });
      const list = $('[data-cx-look-list]', sec);
      list.addEventListener('pointerover', (e) => { const r = e.target.closest('.cx-piece'); if (r) light(Number(r.dataset.i)); });
      list.addEventListener('pointerleave', () => light(-1));
    },

    /* Featured product: photo strip + the short product form */
    featured(sec, cfg) {
      const fp = CX.byId(cfg.id);
      if (!fp) return;
      const track = $('[data-cx-feature-track]', sec);
      const shots = fp.gallery.slice(0, Math.max(1, Number(cfg.photos) || fp.gallery.length));
      track.innerHTML = shots.map((u, i) => `<div>${CX.pic(u, { sizes: '(min-width: 900px) 28vw, 86vw', alt: `${fp.name}, photo ${i + 1}` })}</div>`).join('');
      $('[data-cx-feature-info]', sec).innerHTML = `${cfg.label ? `<span class="cx-feature__label">${esc(cfg.label)}</span>` : ''}${CX.pform(fp, false)}`;
      const count = $('[data-cx-feature-count]', sec);
      const per = () => (CX.wide() ? 2 : 1);
      const step = () => (track.firstElementChild ? track.firstElementChild.offsetWidth + 10 : 0);
      const sync = () => { const i = Math.round(track.scrollLeft / Math.max(1, step())); count.textContent = `${pad(Math.min(shots.length, i + per()))} / ${pad(shots.length)}`; };
      track.addEventListener('scroll', sync, { passive: true });
      $('[data-cx-feature-prev]', sec).addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      $('[data-cx-feature-next]', sec).addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      $$('.cx-feature__bar', sec).forEach((b) => { b.hidden = shots.length <= per(); });
      sync();
    },

    /* Lookbook (Seasonal edit): portrait looks slide over each other on a short pinned run */
    lookbook(sec, cfg) {
      const looks = (cfg.looks || []).filter(Boolean).map(([id, img]) => ({ p: CX.byId(id), img })).filter((x) => x.p && x.img);
      sec.style.setProperty('--n', Math.max(1, looks.length - 1));
      const stage = $('[data-cx-stack-cards]', sec);
      stage.innerHTML = looks.map((x, k) => `
        <a class="cx-look-card" href="${R.product(x.p.id)}" style="z-index:${k + 1}">
          ${CX.pic(x.img, { alt: x.p.name, sizes: '(min-width: 900px) 34vw, 62vw', lazy: k > 1 })}
          <span class="cx-look-card__cap"><span>${esc(x.p.name)}</span>${cfg.button ? `<span class="cx-link">${esc(cfg.button)}</span>` : ''}</span>
        </a>`).join('');
      const minis = (cfg.products || []).map(CX.byId).filter(Boolean);
      $('[data-cx-stack-items]', sec).innerHTML = minis.map((p) => `
        <a href="${R.product(p.id)}" data-id="${esc(p.id)}">${CX.pic(p.gallery[0], { w: 120, sizes: '34px' })}<span>${esc(p.name)}</span>${CX.price(p)}</a>`).join('');
      const text = $('[data-cx-stack-text]', sec);
      if (text && cfg.textMobile && !CX.wide()) text.textContent = cfg.textMobile;
      const cards = $$('.cx-look-card', stage);
      const minEls = $$('.cx-mini a', sec);
      // All looks share one stage, so they arrive together: load and decode them before the section pins.
      if ('IntersectionObserver' in window) {
        const warm = new IntersectionObserver((en) => {
          if (!en.some((x) => x.isIntersecting)) return;
          warm.disconnect();
          $$('img', stage).forEach((img) => { img.loading = 'eager'; if (img.decode) img.decode().catch(() => {}); });
        }, { rootMargin: '1200px 0px' });
        warm.observe(sec);
      }
      let shown = -1;
      onScrollFrame(sec, () => {
        if (!CX.wide()) { cards.forEach((c) => { c.style.transform = ''; c.style.removeProperty('--shade'); }); return; }
        const r = sec.getBoundingClientRect();
        if (r.bottom < -100 || r.top > window.innerHeight + 100) return;
        const p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - window.innerHeight)));
        const f = CX.calm ? Math.round(p * (cards.length - 1)) : p * (cards.length - 1);
        cards.forEach((c, i) => {
          const d = i - f;
          if (d >= 1) { c.style.transform = 'translate3d(0, 110%, 0)'; c.style.setProperty('--shade', 0); return; }
          if (d > 0) { c.style.transform = `translate3d(0, ${(d * 110).toFixed(2)}%, 0)`; c.style.setProperty('--shade', 0); return; }
          const back = Math.min(-d, 3);
          c.style.transform = `translate3d(0, ${(-back * 14).toFixed(1)}px, 0) scale(${(1 - back * 0.05).toFixed(4)})`;
          c.style.setProperty('--shade', (Math.min(-d, 1) * 0.35).toFixed(3));
        });
        const now = Math.min(cards.length - 1, Math.round(f));
        if (now !== shown && looks[now]) { shown = now; minEls.forEach((m) => m.classList.toggle('is-on', m.dataset.id === looks[now].p.id)); }
      });
    },

    /* Photo gallery (Everyday edit): a compact curved carousel that drifts with the page */
    gallery(sec, cfg) {
      const shots = (cfg.photos || []).filter(Boolean).map(([id, img, link]) => ({ p: CX.byId(id), img, link })).filter((x) => x.img);
      const track = $('[data-cx-arc-track]', sec);
      const bar = $('[data-cx-arc-bar]', sec);
      const card = (s) => `<a class="cx-arc__card" href="${s.link || (s.p ? R.product(s.p.id) : R.shop)}">
        ${CX.pic(s.img, { alt: s.p ? s.p.name : '', w: 480, sizes: '(min-width: 768px) 210px, 150px' })}
        ${s.p ? `<span class="cx-arc__tag">${esc(s.p.name)}<span>${CX.money(s.p.price)}</span></span>` : ''}</a>`;
      track.innerHTML = shots.concat(shots).map((x, i) => card(x).replace('class="cx-arc__card"', `class="cx-arc__card${i >= shots.length ? ' cx-arc__dup' : ''}"`)).join('');
      const cards = $$('.cx-arc__card', track);
      // Card positions are measured once (and on resize), so each frame only writes transforms.
      let spots = [];
      let set = 0;
      const measure = () => { spots = cards.map((c) => ({ c, mid: c.offsetLeft + c.offsetWidth / 2 })); set = track.scrollWidth / 2; };
      measure();
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      // Phones: a plain swipe row (scroll-linked motion stutters under touch scrolling); the bar follows the swipe.
      const phone = window.matchMedia('(max-width: 767px)');
      track.addEventListener('scroll', () => {
        if (!phone.matches) return;
        const max = track.scrollWidth - track.clientWidth;
        bar.style.width = `${max > 0 ? ((track.scrollLeft / max) * 100).toFixed(1) : 0}%`;
      }, { passive: true });
      onScrollFrame(sec, () => {
        if (phone.matches) { track.style.transform = ''; cards.forEach((c) => { c.style.transform = ''; }); return; }
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const r = sec.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
        // Travel at most 80% of one set, starting a little in, so the row is always full.
        const x = -(vw * 0.1) - p * Math.min(set * 0.8, Math.max(0, set - vw * 0.1));
        track.style.transform = `translate3d(${x.toFixed(1)}px, 0, 0)`;
        bar.style.width = `${(p * 100).toFixed(1)}%`;
        if (CX.calm) return;
        spots.forEach(({ c, mid }) => {
          const k = Math.max(-1, Math.min(1, (mid + x - vw / 2) / vw));
          c.style.transform = `translate3d(0, ${(k * k * 46).toFixed(1)}px, 0) rotate(${(k * 7).toFixed(2)}deg)`;
        });
      });
    },

    /* Search results: product cards */
    results(sec, cfg) {
      const grid = $('[data-cx-results]', sec);
      if (grid) grid.innerHTML = (cfg.handles || []).map(CX.byId).filter(Boolean).map((p, i) => CX.card(p, { delay: (i % 4) * 60 })).join('');
    },

    /* About: product photo row */
    photos(sec, cfg) {
      $('[data-cx-photos]', sec).innerHTML = (cfg.handles || []).map(CX.byId).filter(Boolean).map((p, i) => `
        <a class="cx-photo" href="${R.product(p.id)}" data-cx-unveil style="--d:${i * 70}ms">
          <span class="cx-photo__media">${CX.pic(p.gallery[0], { alt: p.name, sizes: '(min-width: 900px) 25vw, 50vw' })}</span>
          <span class="cx-photo__name">${esc(p.name)}</span>
        </a>`).join('');
    },
  };

  const start = (sec) => {
    const kind = sec.dataset.cxKind;
    if (!init[kind]) return;
    (cleanups.get(sec) || []).forEach((fn) => fn());
    cleanups.delete(sec);
    CX.readSeeds(sec);
    try { init[kind](sec, config(sec)); } catch (e) { console.error('[corsac]', kind, e); }
    if (CX.observe) CX.observe(sec);
  };
  $$('[data-cx-kind]').forEach(start);
  document.addEventListener('shopify:section:load', (e) => $$('[data-cx-kind]', e.target).forEach(start));
})();
